/* eslint-disable import/no-cycle */
import ListQuestions from './ListQuestions';

export default ListQuestions;
